import { AlertColor } from "@mui/material"
import { GallerySection } from "@/shared/types/product"

const MAX_BULK_IMAGES = 10

type SelectedImage = {
  id: string
  file: File
  previewUrl: string
}

type Notify = (message: string, type?: AlertColor) => void

const toBulkSections = (selectedImages: SelectedImage[], selectedPromptId: string): GallerySection[] => {
  return selectedImages.map((image, index) => ({
    id: index + 1,
    images: [image.previewUrl],
    files: [image.file],
    selectedIndex: 0,
    name: image.file.name,
    description: "",
    keywords: [],
    category: "",
    price: "",
    selectedPromptIds: [selectedPromptId]
  }))
}

export { MAX_BULK_IMAGES, toBulkSections }
export type { SelectedImage, Notify }
